const getRedirerectUrl = (currentUrl: string) => {
    if(currentUrl === "/") return "/";
    if(currentUrl.toLowerCase().startsWith("/admin")) return currentUrl;
    

    let groups = currentUrl.trim().split("/");
    for (let i = 0; i < groups.length; i++) {
        if(groups[i].length > 0) {
            return `/${groups[i]}`;
        }
    } 

    return "/";
}

export { getRedirerectUrl }
